import { createApi } from '@reduxjs/toolkit/query/react';
import { API, API_PREFIX } from '../../constants';
import { baseQuery } from './base.query';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: baseQuery,
  tagTypes: ['Auth'],
  endpoints: (builder) => ({
    getPageConfig: builder.query({
      query: (token: string) => ({
        url: API_PREFIX.NEXTGEN + API.PAGE_CONFIG,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
    getUserAppConfig: builder.query({
      query: (token: string) => ({
        url: API_PREFIX.NEXTGEN + API.GET_USER_APP_CONFIG,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetPageConfigQuery, useLazyGetPageConfigQuery, useGetUserAppConfigQuery } =
  authApi;
